import CalendarView from '@/components/calendar/CalendarView'
import { Button } from '@/components/ui/button'
import { expandApprovedLeaveRequestsToDates } from '@/lib/time'
import { useTRPC } from '@/trpc/react'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { type } from 'arktype'
import { ChevronLeft } from 'lucide-react'

export const Route = createFileRoute('/dashboard/hr_admin/employees/$employeeId/leave_calendar/')({
  component: RouteComponent,
  validateSearch: type({
    view: 'string = "month"',
  }),
})

function RouteComponent() {
  const { employeeId } = Route.useParams()
  const { view } = Route.useSearch()
  const api = useTRPC()

  const { data: employee, isPending: isPendingEmployee } = useQuery({
    ...api.employee.getEmployeeByEmployeeId.queryOptions({ employeeId }),
    enabled: !!employeeId,
  })

  const { data: requests } = useQuery({
    ...api.leave.getMyLeaveRequests.queryOptions({ employeeId: employee?.userId ?? undefined }),
    enabled: !!employee?.userId,
  })

  const leaveDates = expandApprovedLeaveRequestsToDates(requests ?? [])

  const title =
    isPendingEmployee || !employee
      ? 'Leave Calendar'
      : `Leave Calendar — ${employee.firstName} ${employee.lastName}`

  return (
    <div>
      <div className="mb-2">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/dashboard/hr_admin/employees/$employeeId" params={{ employeeId }}>
            <ChevronLeft className="mr-1" />
            Back to employee settings
          </Link>
        </Button>
      </div>
      <CalendarView view={view} leaveDates={leaveDates} title={title} />
    </div>
  )
}
